/* eslint-disable no-unused-vars */
/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
import React from 'react';

const LiveMarketWheel = () => {
    return (
        <img src='' id="liveMarkets__wheelGif" alt="Live Markets Wheel"/>
    );
}

export default LiveMarketWheel;



// WEBPACK FOOTER //
// ./frontend/pages/LiveMarkets/animations/liveMarketWheel/liveMarketWheel.jsx